<template>
  <div class="mz-antd-pagination">
    <span class="mz-pagination-total">{{ totalLabel }} {{ safeTotal }}</span>
    <span class="mz-pagination-current">{{ currentLabel }} {{ currentPage }} / {{ displayPageCount }}</span>
    <button
      class="mz-pagination-button"
      type="button"
      :disabled="loading || currentPage <= 1"
      @click="changePage(currentPage - 1)"
    >{{ prevLabel }}</button>
    <button
      class="mz-pagination-button"
      type="button"
      :disabled="loading || !canGoNext"
      @click="changePage(currentPage + 1)"
    >{{ nextLabel }}</button>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    value: {
      type: Number,
      default: undefined
    },
    current: {
      type: Number,
      default: undefined
    },
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 50
    },
    loading: {
      type: Boolean,
      default: false
    },
    hasNext: {
      default: null
    },
    totalLabel: {
      type: String,
      default: '\u603b\u6570'
    },
    currentLabel: {
      type: String,
      default: '\u5f53\u524d\u9875'
    },
    prevLabel: {
      type: String,
      default: '\u4e0a\u4e00\u9875'
    },
    nextLabel: {
      type: String,
      default: '\u4e0b\u4e00\u9875'
    }
  },
  data() {
    return {
      internalCurrent: 1
    }
  },
  computed: {
    safeTotal() {
      const total = Number(this.total)
      return Number.isFinite(total) && total > 0 ? Math.floor(total) : 0
    },
    safePageSize() {
      const pageSize = Number(this.pageSize)
      return Number.isFinite(pageSize) && pageSize > 0 ? Math.floor(pageSize) : 50
    },
    currentPage() {
      const current = Number(this.internalCurrent)
      return Number.isFinite(current) && current > 0 ? Math.floor(current) : 1
    },
    pageCount() {
      if (this.safeTotal <= 0) {
        return 1
      }
      return Math.max(1, Math.ceil(this.safeTotal / this.safePageSize))
    },
    displayPageCount() {
      return Math.max(this.pageCount, this.currentPage)
    },
    canGoNext() {
      if (this.hasNext !== null && this.hasNext !== undefined) {
        return !!this.hasNext
      }
      return this.currentPage < this.pageCount
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.syncCurrent(value)
      }
    },
    current: {
      immediate: true,
      handler(value) {
        this.syncCurrent(value)
      }
    }
  },
  methods: {
    syncCurrent(value) {
      const current = Number(value)
      if (Number.isFinite(current) && current > 0) {
        this.internalCurrent = Math.floor(current)
      }
    },
    changePage(page) {
      const nextPage = Math.max(1, Math.floor(Number(page) || 1))
      if (nextPage == this.currentPage || this.loading) {
        return
      }
      if (nextPage > this.displayPageCount && !this.canGoNext) {
        return
      }
      this.internalCurrent = nextPage
      this.$emit('input', nextPage)
      this.$emit('change', nextPage)
      this.$emit('onShowSizeChange', nextPage, this.safePageSize)
    }
  }
}
</script>

<style scoped>
.mz-antd-pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin-top: 16px;
  color: #262626;
  font-size: 13px;
  line-height: 20px;
  box-sizing: border-box;
}

.mz-pagination-total,
.mz-pagination-current {
  white-space: nowrap;
}

.mz-pagination-button {
  min-width: 68px;
  height: 30px;
  padding: 0 12px;
  border: 0;
  border-radius: 2px;
  background: #eff2ee;
  color: #262626;
  font-size: 13px;
  line-height: 30px;
  cursor: pointer;
}

.mz-pagination-button:hover:not(:disabled) {
  background: #000;
  color: #fff;
}

.mz-pagination-button:disabled {
  color: #9b9b9b;
  cursor: not-allowed;
  opacity: 0.72;
}
</style>
